module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db centered-container-ns inter lh-copy flex justify-center"
  }, [_c('div', {
    staticClass: "bg-white shadow-theme-ns w-100 mw7 ph4 mt6 pv5-ns br1-ns"
  }, [_c('div', {
    staticClass: "mv3 tc f3"
  }, [_vm._v("AKKO Plan Family Sign-up")]), _vm._v(" "), _c('div', {
    staticClass: "mt4 mb4 pt4 grid-half"
  }, [_c('div', [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "adults"
    }
  }, [_vm._v("Adults:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adults),
      expression: "adults"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "adults",
      "name": "adults"
    },
    on: {
      "blur": _vm.submit,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.adults = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.PLAN_TYPE_MAX), function(num, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(index))])
  }), 0)]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "students"
    }
  }, [_vm._v("Students:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.students),
      expression: "students"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "students",
      "name": "students"
    },
    on: {
      "blur": _vm.submit,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.students = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.PLAN_TYPE_MAX), function(num, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(index))])
  }), 0)])]), _vm._v(" "), _c('router-link', {
    staticClass: "no-underline",
    attrs: {
      "to": "/registration-v2/family/choose-plan"
    }
  }, [_c('ak-button', {
    staticClass: "mt4",
    attrs: {
      "primary": "",
      "block": "",
      "disabled": !_vm.valid
    }
  }, [_vm._v("Next")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883224b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration-v2/ChooseQuantity.vue
// module id = 1215
// module chunks = 0